import request from "@/utils/request";

export function login(data) {
    // 修改登录请求数据格式 json->x-www-form-urlencoded
  const params = new URLSearchParams();
  params.append('account', data.account); 
  params.append('password', data.password);

  return request({
    url: '/manage/login',
    method: 'post',
    data: params, // 直接传递 URLSearchParams 对象
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

// 退出登录接口
export function logout() {
  return request({
    url: '/manage/login_out',
    method: 'get'
  });
}

// 获取验证码接口
// 该接口用于获取登录时的验证码
// 返回的数据格式为Base64编码的图片
export function getVerifyCode() {
  return request({
    url: '/captcha',
    method: 'get',
  });
}

// 验证验证码
export function verifyCode(data) {
  const formData = new FormData();
  formData.append('uuid', data.msg); // 验证码的唯一标识
  formData.append('code', data.code); // 验证码内容

  return request({
    url: '/verify',
    method: 'post',
    data: formData,
  });
}

//---------------------------------------------------------------
//教师登录相关
//通过域名获取学校信息
/**
 * 通过域名获取学校信息
 * @param {String} params.domain 
 * @returns 
 */
export function getSchoolInfoByDomain(params) {
  return request({
    url: '/course/selectdomain',
    method: 'get',
    params: params,
  });
}

// 学生登录接口
// 根据接口文档：GET方法，需要number、password、schooid三个参数
export function studentLogin(data) {
  return request({
    url: '/user/login',
    method: 'get',
    params: {
      number: data.number,
      password: data.password,
      schoolId: data.schoolId 
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

// 教师退出登录接口
export function teacherLogout() {
  return request({
    url: '/manage/login_out',
    method: 'get'
  });
}

// 学生退出登录接口

export function studentLogout(params) {
  return request({
    url: '/user/logout',
    method: 'get',
    params
  });
}